export default {
  name: 'marking--importThirdCountryH',
  apiService: 'shoes',
  apiPath: '/admin/import_h',
  enums: {
    docType: ['DECLARATION', 'STATEMENT'],
    status: ['IN_PROGRESS', 'CHECKED_OK', 'CHECKED_NOT_OK', 'PROCESSING_ERROR', 'UNDEFINED'],
  },
};
